import { render } from "./ZuschussMitEingabe.pug?vue&type=template&id=2526c00e&lang=pug"
import script from "./ZuschussMitEingabe.js?vue&type=script&lang=js"
export * from "./ZuschussMitEingabe.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__